import { render } from "./App.vue?vue&type=template&id=1ecb0ae0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1ecb0ae0&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.2.13_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__